/* eslint-disable react-hooks/exhaustive-deps */
import { Paper, Slider } from "@mui/material";
import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../components/pageTitle";
import { handleThemeToggle } from "../../redux/actoin";
const Settings = () => {
  const [value, setValue] = useState(13);
  const [pageType, setpageType] = useState(2);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    localStorage.setItem("fontSize", newValue);
    document.documentElement.style.fontSize = `${Number(newValue)}px`;
    setValue(newValue);
  };
  useLayoutEffect(() => {
    if (localStorage.getItem("fontSize")) {
      setValue(Number(localStorage.getItem("fontSize")));
    }
    if (localStorage.getItem("pageType")) {
      setpageType(Number(localStorage.getItem("pageType")));
    }
  }, []);
  const AppVersion = useSelector((state) => state.AppVersion);
  const { version } = AppVersion;
  return (
    <>
      <PageTitle title="  تنظیمات سایت " />
      <div className="md:mx-3 mx-1 mt-8">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
          className="relative z-50"
        >
          <div className="flex  flex-col gap-4">
            <div className="flex gap-5 items-center">
              <span className="text-sm"> ورژن : </span>
              <span className="text-sm font-bold">{version}</span>
            </div>
            <div className="flex gap-6 items-center flex-wrap">
              <span className="text-sm">سایز فونت : </span>
              <div className="w-full md:w-[400px]">
                <Slider
                  sx={{
                    mt: 2,
                    ".MuiSlider-thumb": {
                      background: "#fff !important",
                      border: "4px solid currentColor !important",
                      width: "25px  !important",
                      height: "25px  !important",
                      transform: "translate(0%, -50%) !important",
                    },
                  }}
                  aria-label="Temperature"
                  value={value}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  step={1}
                  min={10}
                  max={20}
                />
              </div>
            </div>

            <div className="flex gap-6 items-center flex-wrap">
              <span className="text-sm"> تم : </span>
              <div className="flex flex-wrap gap-2">
                <div
                  onClick={() => dispatch(handleThemeToggle("light"))}
                  className="w-36 h-[3.07rem] rounded-md flex relative z-40  justify-center items-center cursor-pointer text-[#eeeeee] bg-[#725eda] border"
                >
                  تم بنفش
                </div>
                <div
                  onClick={() => {
                    dispatch(handleThemeToggle("blue"));
                  }}
                  className="w-36 h-[3.07rem] rounded-md flex justify-center relative z-40 items-center cursor-pointer bg-[#3b5396] text-white border border-white"
                >
                  تم آبی
                </div>
                <div
                  onClick={() => {
                    dispatch(handleThemeToggle("green"));
                  }}
                  className="w-36 h-[3.07rem] rounded-md flex justify-center relative z-40 items-center cursor-pointer bg-[#03765b] text-white border border-white"
                >
                  تم سبز
                </div>
                <div
                  onClick={() => {
                    dispatch(handleThemeToggle("orange"));
                  }}
                  className="w-36 h-[3.07rem] rounded-md flex justify-center relative z-40 items-center cursor-pointer bg-[#f99f04] text-white border border-white"
                >
                  تم نارنجی
                </div>
                <div
                  onClick={() => {
                    dispatch(handleThemeToggle("dark"));
                  }}
                  className="w-36 h-[3.07rem] rounded-md flex justify-center relative z-40 items-center cursor-pointer bg-[#040537] text-white border border-white"
                >
                  تم تیره
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
};

export default Settings;
